// extracted by mini-css-extract-plugin
export default {"contain":"Status_contain__2W8gI","button":"Status_button__h4QF5"};